'use client';

import { useEffect } from 'react';

import { clearCampaignPreview } from '../../_utils/campaignPreview';

//* 상세 본문이 마운트되면 프리뷰를 걷는다 — 페이지와 layout이 형제라 스토어로 신호를 보낸다
export const CampaignEntryPreviewDismiss = () => {
  useEffect(() => {
    clearCampaignPreview();
  }, []);

  return null;
};
